import { useSyncExternalStore } from 'react';

// Module-level so the optimistic value survives the page-tree remount that
// happens when a new agent transitions to saved.
const pendingByAgentId = new Map<string, string | null>();
const listenersByAgentId = new Map<string, Set<() => void>>();

function notify(agentId: string): void {
  const set = listenersByAgentId.get(agentId);
  if (set === undefined) {
    return;
  }
  for (const listener of set) {
    listener();
  }
}

export function setPendingEmoji(agentId: string, value: string | null): void {
  pendingByAgentId.set(agentId, value);
  notify(agentId);
}

export function clearPendingEmoji(agentId: string): void {
  pendingByAgentId.delete(agentId);
  notify(agentId);
}

function subscribe(agentId: string, listener: () => void): () => void {
  let set = listenersByAgentId.get(agentId);
  if (set === undefined) {
    set = new Set();
    listenersByAgentId.set(agentId, set);
  }
  set.add(listener);
  return () => {
    set?.delete(listener);
  };
}

export function usePendingEmoji(agentId: string): string | null | undefined {
  return useSyncExternalStore(
    (cb) => subscribe(agentId, cb),
    () => pendingByAgentId.get(agentId),
    () => undefined
  );
}
